import Request from './src/request'
import en from "./src/lang/en-US";
import zh from "./src/lang/zh-CN";

export const request = Request
export const CryptoJS = require('./src/CryptoJS')
export const enLocale = en;
export const zhLocale = zh;
